import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Loan_API } from "../../Helper";

import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  
  FaFileInvoiceDollar,
 
  FaExclamationTriangle,

  FaUniversity,

  FaBalanceScale,
  FaBook,
 
  FaLock,
  FaMoneyBillWave,
  FaMoneyCheckAlt,
  FaWallet,FaShieldAlt,
  FaUserFriends,
  FaCreditCard,
  FaBookOpen,
  FaClock,
  FaMotorcycle, 
  FaRedo,
  FaBolt,
  FaPercentage
} from "react-icons/fa";
import {
    FaBirthdayCake ,
    FaBriefcase,
    FaUserCheck,
    FaChartLine,
    FaHome,
    FaIdCard
} from "react-icons/fa";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const TwoWheelerLoanNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
        question: ' What is a two-wheeler loan?',
        answer:
            'A two-wheeler loan is a financial arrangement in which a lender provides funds to help you purchase a motorcycle or scooter. You agree to repay the loan over a specified period, typically with interest, through regular installments. The vehicle often serves as collateral, allowing the lender to repossess it if you default on payments.',
    },
    {
        question: 'What factors should I consider when choosing a two-wheeler loan?',
        answer:
            'When choosing a two-wheeler loan, consider factors like the interest rate, loan term, monthly payment amount, total loan cost, and additional fees. You should also assess your credit score, as it can affect your eligibility and the interest rate. Check for prepayment penalties and other terms that could affect your flexibility.',
    },
    {
        question: '  Which bank offers the lowest interest rate on two-wheeler loans?',
        answer:
            'The interest rate for two-wheeler loans depends on various factors, including the loan amount, your credit score, loan tenure, and financial history. To find the lowest rate, compare offers from different banks and lending institutions. You can get personalized rates by providing your financial information to lenders and using our comparison tools to assess your options.',
    },
    {
        question: 'Can I get a two-wheeler loan through TheFinMaster.com?',
        answer:
            ' TheFinMaster.com does not offer two-wheeler loans directly. Instead, we provide educational resources, loan comparison tools, and unbiased information to help you understand two-wheeler loans and choose the best one for your needs. Once you have selected a suitable loan, you will be directed to the lenders website to complete a secure application process.',
    },
    {
      question: "What is the minimum and maximum loan amount for a two-wheeler loan?",
      answer:
        "The minimum loan amount for a two-wheeler loan is typically ₹10,000, while the maximum amount can go up to 90–100% of the on-road price of the vehicle, depending on the lender and your eligibility. Some banks may have specific limits for different types of two-wheelers.",
    },
    {
      question: "What is the interest rate on two-wheeler loans?",
      answer:
        "The interest rate for two-wheeler loans usually ranges between 9% and 18%, depending on factors such as the loan amount, tenure, and your credit score. Some lenders may offer special discounts or lower rates for select models or customers with good credit histories.",
    },
    {
      question: "What is the tenure for a two-wheeler loan?",
      answer:
        "The tenure for two-wheeler loans generally ranges from 1 to 5 years. Shorter tenures may have higher EMIs but lower total interest costs, while longer tenures offer lower monthly payments but could result in higher interest payments over time.",
    },
    {
      question: "Do I need a co-applicant for a two-wheeler loan?",
      answer:
        "In most cases, a co-applicant is not required for a two-wheeler loan. However, if your income or credit score does not meet the lender's eligibility criteria, a co-applicant with a stable financial background may improve your chances of approval.",
    },
    {
      question: "What documents are required to apply for a two-wheeler loan?",
      answer:
        "The common documents required for a two-wheeler loan include proof of identity (Aadhar, PAN), proof of address (utility bills or rental agreement), income proof (salary slip, bank statement), and the vehicle’s quotation. Self-employed individuals may need to provide business-related documents.",
    },
    {
      question: "Can I apply for a two-wheeler loan if I have a low credit score?",
      answer:
        "Yes, you can apply for a two-wheeler loan with a low credit score, but your chances of approval may decrease, and the interest rate might be higher. Some lenders may still approve loans with a lower credit score, particularly if you provide a co-applicant or additional documentation.",
    },
    {
      question: "Is it possible to prepay my two-wheeler loan?",
      answer:
        "Yes, you can prepay your two-wheeler loan, either partially or fully, before the loan tenure ends. However, some lenders may charge a prepayment penalty, so it's important to check the loan agreement and discuss the terms with your lender.",
    },
    {
      question: "Can I get a two-wheeler loan for a second-hand bike?",
      answer:
        "Yes, many lenders offer loans for second-hand or used bikes. However, the loan amount for a second-hand bike may be lower than for a new one, and the interest rates may also be slightly higher. The condition of the bike and its age play a role in loan approval.",
    },
    {
      question: "What happens if I miss an EMI payment for my two-wheeler loan?",
      answer:
        "If you miss an EMI payment, the lender may charge a late fee and report the missed payment to credit bureaus, which could negatively affect your credit score. Repeated defaults can lead to the loan being considered a non-performing asset (NPA), and legal actions may follow.",
    },
    {
      question: "Can I transfer my two-wheeler loan to another lender?",
      answer:
        "Yes, you can transfer your two-wheeler loan to another lender if you find a more favorable interest rate or loan terms. This process is known as loan balance transfer, and it typically involves a processing fee, but it can help you save on interest over the long term.",
    },
    {
      question: "Are there any hidden charges in a two-wheeler loan?",
      answer:
        "Some hidden charges to look out for in a two-wheeler loan include processing fees, prepayment penalties, documentation charges, and insurance costs. It's important to read the loan agreement carefully to ensure you’re aware of all the applicable fees before signing.",
    },
    {
      question: "Can I get a two-wheeler loan without a down payment?",
      answer:
        "While most lenders require a down payment (usually around 10–15% of the on-road price), some offer loans with zero down payment, particularly for select models or customers with excellent credit histories. It’s advisable to check with different lenders to explore these offers.",
    },
    {
      question: "How is the eligibility for a two-wheeler loan determined?",
      answer:
        "Eligibility for a two-wheeler loan is determined by factors such as your age, income, credit score, employment status, and the vehicle’s price. Lenders generally require applicants to be between 21 and 60 years old, have a stable income, and maintain a good credit history.",
    }
];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchLoanData();
  }, []);
  const fetchLoanData = async () => {
    try {
      const response = await Http.get(Loan_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.loan || response;

      // Filter the insurance data to show only Car category
      const carLoanData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Two Wheeler Loan")
        : [];

      setLoanData(carLoanData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Loan data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const loanTypes = [
    {
      name: "New Two-Wheeler Loan 🏍️",
      description:
        "A standard loan provided to individuals looking to purchase a brand-new bike or scooter. Lenders typically finance up to 90-100% of the on-road price, depending on the borrower's profile and lender policies.",
      icon: <FaMotorcycle />,
    },
    {
        name: "Two-Wheeler Loan with No Down Payment 💳",
        description:
          " Some banks and NBFCs offer zero down payment loans, where 100% of the bike's cost is financed, reducing the need for an upfront payment. However, such loans may come with higher interest rates or stricter eligibility criteria.",
        icon: <FaCreditCard />,
      },
      {
        name: "Two-Wheeler Loan for Bad Credit Holders ⚠️",
        description:
          "Special financing options for individuals with low or no credit scores. These loans may require a higher interest rate, additional guarantors, or collateral security.",
        icon: <FaExclamationTriangle />,
      },
    {
      name: "Used Two-Wheeler Loan 🔄",
      description:
        "Designed for purchasing pre-owned bikes or scooters, these loans generally have a lower loan-to-value (LTV) ratio, covering up to 75-80% of the bike’s valuation. Interest rates may be slightly higher due to the depreciated value of used vehicles.",
      icon: <FaRedo />,
    },
   
   

    {
      name: "Electric Two-Wheeler Loan ⚡",
      description:
        " With the growing focus on sustainable transportation, many lenders offer loans specifically for electric two-wheelers. These loans may come with lower interest rates, government subsidies, or incentives to encourage eco-friendly vehicle adoption.",
      icon: <FaBolt />,
    },

  
  ];

    const benefitshealth = [
        {
            title: "New Two-Wheeler Loan",
            description:
              "A standard loan provided to individuals looking to purchase a brand-new bike or scooter. Lenders typically finance up to 90-100% of the on-road price, depending on the borrower's profile and lender policies.",
            icon: <FaMotorcycle className="text-4xl text-blue-600" />,
          },
       
          {
            title: "Used Two-Wheeler Loan",
            description:
              " Designed for purchasing pre-owned bikes or scooters, these loans generally have a lower loan-to-value (LTV) ratio, covering up to 75-80% of the bike’s valuation. Interest rates may be slightly higher due to the depreciated value of used vehicles.",
            icon: <FaRedo className="text-4xl text-green-600" />,
          },
          {
            title: "Electric Two-Wheeler Loan",
            description:
              " With the growing focus on sustainable transportation, many lenders offer loans specifically for electric two-wheelers. These loans may come with lower interest rates, government subsidies, or incentives to encourage eco-friendly vehicle adoption.",
            icon: <FaBolt className="text-4xl text-purple-600" />,
          },
          
          {
            title: "Two-Wheeler Loan for Bad Credit Holders",
            description:
              " Special financing options for individuals with low or no credit scores. These loans may require a higher interest rate, additional guarantors, or collateral security.",
            icon: <FaExclamationTriangle  className="text-4xl text-red-600" />,
          },
            {
              title: "Two-Wheeler Loan with No Down Payment",
              description:
                " Some banks and NBFCs offer zero down payment loans, where 100% of the bike's cost is financed, reducing the need for an upfront payment. However, such loans may come with higher interest rates or stricter eligibility criteria.",
              icon: <FaCreditCard className="text-4xl text-orange-600" />,
            },
            
            
          ];







  const points = [
    {
      title: " Lower Interest Rates ",
      description: ` Compared to personal loans, two-wheeler loans have lower interest rates.`,
    },
    {
      title: " High Loan-to-Value (LTV) Ratio",
      description: `  Many lenders finance up to 100% of the bike’s cost, reducing upfront expenses.`,
    },
    {
      title: "Easy Eligibility",
      description: ` Two-wheeler loans are easier to obtain, even for individuals with lower credit scores.`,
    },
    {
      title: "Flexible Repayment Tenure",
      description: `  Borrowers can choose repayment terms from 12 to 60 months based on their budget.`,
    },
    {
      title: "Builds Credit Score  ",
      description: `Timely repayments help improve your CIBIL score, increasing future loan eligibility`,
    },
  ];
  const points1 = [
    {
      title: " Bike as Collateral",
      description: `The lender holds ownership of the vehicle until the loan is repaid.`,
    },
    {
      title: " Down Payment Requirement  ",
      description: ` Some lenders require a down payment, increasing upfront costs.`,
    },
    {
      title: "Additional Charges ",
      description: `Processing fees, documentation charges, and foreclosure penalties may apply.`,
    },
    {
      title: "Depreciation Impact ",
      description: ` The bike's value depreciates over time, reducing resale value while the loan is still being repaid.`,
    },
 
  ];

  const points3 = [
    {
      title: " Interest Rate",
      points: [
        "Compare interest rates from different banks and NBFCs. A lower interest rate reduces your total repayment amount. Check if the rate is fixed or floating, as this affects the EMI structure.",
      ],
    },
    {
      title: " Loan Amount & LTV Ratio",
      points: [
        "Most lenders offer up to 90-100% financing of the bike’s on-road price. If you prefer lower EMIs, consider making a higher down payment.",
     
      ],
    },
    {
      title: " Loan Tenure",
      points: [
        "The tenure typically ranges between 12 to 60 months. A longer tenure results in lower EMIs but higher overall interest, while a shorter tenure reduces total interest but increases EMI. Choose based on your repayment capacity.",
      ],
    },
    {
      title: " Processing Fees & Additional Charges",
      points: [
        "Lenders may charge processing fees, foreclosure charges, late payment penalties, and other hidden costs. Always check the total cost of the loan before finalizing.",
      ],
    },
    {
      title: "Eligibility Criteria",
      points: [
        "Each lender has different requirements for age, income, employment, and credit score. Ensure you meet the criteria before applying to avoid rejections, which can impact your credit score.  ",
      ],
    },
    {
      title: "  Credit Score Impact",
      points: [
        "A higher CIBIL score (750+) improves loan approval chances and helps you secure better interest rates. If your score is low, look for lenders offering loans with flexible criteria.",
      ],
    },
    {
      title: " EMI Affordability & Repayment Flexibility",
      points: [
        "Use an EMI calculator to check if the monthly installments fit your budget. Also, confirm whether the lender allows prepayment or foreclosure without hefty penalties.",
      ],
    },
    {
      title: " . Insurance Bundling & Additional Offers",
      points: [
        "Some lenders provide insurance coverage along with the loan, covering bike damage or theft. Also, check for seasonal offers, cashback, or discounts on processing fees.",
      ],
    },
  ];

  const eligibilityCriteria = [
    {
      title: "Loan Amount",
      points: [
        " The principal amount borrowed to purchase the two-wheeler. Lenders typically finance 75% to 100% of the vehicle's on-road price, depending on the borrower's eligibility.",
      ],
      icon: <FaMotorcycle className="text-blue-500 text-2xl" />,
    },
    {
        title: "Down Payment Requirement",
        points: [
          " Many lenders require borrowers to make a down payment of 10-25% of the bike’s cost, while some offer zero down payment loans for eligible applicants.",
        ],
        icon: <FaCreditCard className="text-orange-500 text-2xl" />,
      },
      {
          title: "Collateral & Security",
          points: [
            "Since a two-wheeler loan is secured, the vehicle itself serves as collateral. In case of default, the lender can seize and sell the bike to recover dues.",
          ],
          icon:  <FaLock className="text-orange-500 text-2xl" />,
        },
        {
          title: "Insurance Requirement",
          points: [
            " Most lenders require comprehensive two-wheeler insurance before approving a loan, ensuring financial protection against theft, accidents, or damages.",
          ],
          icon: <FaShieldAlt className="text-orange-500 text-2xl" />,
        },
        {
            title: "Equated Monthly Instalment (EMI)",
            points: [
              " The fixed monthly payment that includes both principal and interest. EMI depends on the loan amount, interest rate, and tenure, with lenders offering EMI calculators to help borrowers plan their repayment.",
            ],
            icon: <FaFileInvoiceDollar className="text-purple-500 text-2xl" />,
          },
          {
            title: "Interest Rate",
            points: [
              " The cost of borrowing is expressed as an annual percentage rate (APR). Interest rates vary based on factors like credit score, loan tenure, and lender policies. Generally, rates range between 8% to 18% per annum.",
            ],
            icon: <FaCalendarAlt className="text-blue-500 text-2xl" />,
          },
    {
      title: "Age Criteria",
      points: [
        "The applicant must typically be between 16 to 35 years at the time of applying for the loan.",
        "Some banks may have a maximum age limit of up to 45 years for working professionals opting for executive education loans.",
      ],
      icon: <FaPercentage className="text-green-500 text-2xl" />,
    },
    

    {
      title: "Loan Tenure",
      points: [
        "The repayment duration, typically 12 to 60 months, influences the monthly EMI. A longer tenure reduces EMI but increases overall interest costs, while a shorter tenure results in higher EMI but lower interest expenses.",
      ],
      icon: <FaMoneyCheckAlt className="text-red-500 text-2xl" />,
    },
   

    {
      title: "Processing Fees & Additional Charges",
      points: [
        "Processing Fees: A one-time charge levied for loan processing, usually 1% to 3% of the loan amount.    ",
        "Prepayment Charges: Fees for early loan repayment, applicable in some cases.",
        "Late Payment Penalties: A penalty imposed for missed or delayed EMI payments."
      ],


      icon:  <FaWallet className="text-green-500 text-2xl" />,
    },
    
  ];
  const componentsData1 = [
    {
        title: "Citizenship",
        icon: <FaIdCard className="text-2xl text-pink-600" />,
        points: [
          "Must be an Indian citizen with valid identity and address proof.",
         
        ],
      },
    {
      title: " Age Criteria",
      icon: <FaBirthdayCake className="text-2xl text-yellow-600" />,
      points: [
        "Minimum Age: 18 years (some lenders require 21 years)",
        "Maximum Age: 65 years (at the time of loan maturity)",
      ],
    },
   
    {
      title: "Minimum Income Requirement",
      icon: <FaWallet className="text-2xl text-green-600" />,
      points: [
        "Salaried applicants: ₹10,000 – ₹15,000 per month (varies by lender).",
        "Self-employed applicants: Stable income with proof of business operations for at least 1 year.",
      ],
    },

    {
      title: " Employment Stability",
      icon: <FaUserCheck className="text-2xl text-indigo-600" />,
      points: [
        "Salaried employees: Minimum 6 months to 1 year of work experience.",
        "Self-employed: Minimum 1-2 years of business continuity proof.",
      ],
    },
    {
      title: "Credit Score",
      icon: <FaChartLine className="text-2xl text-blue-600" />,
      points: [
        "A credit score of 650 or above is preferred for better loan terms and lower interest rates.",
        "Applicants with a low credit score may still get a loan but at higher interest rates.",
      ],
    },

    {
      title: "Residential Stability",
      icon: <FaHome className="text-2xl text-purple-600" />,
      points: [
        "Should have a permanent residence or a rented residence with at least 1 year of stay.",
        "Some lenders may require proof of local address.",
      ],
    },

   
    {
        title: "Employment Type",
        icon: <FaBriefcase  className="text-2xl text-red-600" />,
        points: [
          "Salaried Individuals: Must have a stable monthly income.",
          "Self-Employed Individuals: Must have a steady source of income from business or profession.",
          "Students: Some lenders offer two-wheeler loans to students if they have a co-applicant (such as a parent or guardian) with a stable income.",
        ],
      },
      {
        title: "Documents Required for Two-Wheeler Loan",
        icon: <FaBriefcase  className="text-2xl text-red-600" />,
        points: [
          " Identity Proof (Aadhaar card, PAN card, Passport, Voter ID, Driving License)",
          "Address Proof (Utility bills, Rental agreement, Passport, Aadhaar card)",
          " Income Proof (Salary slips, Bank statements, ITR for self-employed individuals)",
          "Employment Proof (Offer letter, Business registration for self-employed)",
          "Photographs (Passport-sized recent photos)"
        ],
      },
  ];
  const comparisonData2 = [
    {
      feature: "Purpose",
      icon: <FaBook className="w-4 h-4 inline-block text-blue-500 mr-1" />,
      educationLoan:
        "Specifically for educational expenses (tuition, books, living costs, etc.)",
      personalLoan: "Can be used for any purpose, including education",
    },
    {
      feature: "Interest Rate",
      icon: (
        <FaPercentage className="w-4 h-4 inline-block text-green-500 mr-1" />
      ),
      educationLoan: "Lower interest rates (typically 8-12%)",
      personalLoan: "Higher interest rates (10-24%)",
    },
    {
      feature: "Loan Amount",
      icon: (
        <FaMoneyBillWave className="w-4 h-4 inline-block text-purple-500 mr-1" />
      ),
      educationLoan:
        "Higher amounts offered, covering up to 100% of tuition fees",
      personalLoan: "Limited based on the borrower's creditworthiness",
    },
    {
      feature: "Repayment Start",
      icon: <FaClock className="w-4 h-4 inline-block text-yellow-500 mr-1" />,
      educationLoan:
        "Repayment starts after course completion + moratorium period",
      personalLoan: "Repayment starts immediately after loan disbursal",
    },
    {
      feature: "Collateral Requirement",
      icon: <FaLock className="w-4 h-4 inline-block text-pink-500 mr-1" />,
      educationLoan: "Required for higher loan amounts (above ₹7.5 lakh)",
      personalLoan:
        "Generally unsecured, but higher loan amounts may need collateral",
    },
    {
      feature: "Tax Benefits",
      icon: (
        <FaFileInvoiceDollar className="w-4 h-4 inline-block text-rose-500 mr-1" />
      ),
      educationLoan:
        "Interest payments qualify for tax deductions under Section 80E of the IT Act",
      personalLoan: "No tax benefits",
    },
    {
      feature: "Co-Applicant Requirement",
      icon: (
        <FaUserFriends className="w-4 h-4 inline-block text-indigo-500 mr-1" />
      ),
      educationLoan: "Mandatory co-applicant (parent/guardian/spouse)",
      personalLoan:
        "Not required unless borrower has low income or poor credit history",
    },
  ];

  return (
    <>
        <Helmet>
            <title>Bike Loan – Attractive Interest Rates, EMI for Two-Wheeler Loans in India 2024 - Thefinmaster</title>
            <meta  name='description' content='Get bike loan with instant approval from top banks in India with best EMI, Interest Rates for two-wheeler purchase at Thefinmaster.'/>
            <meta name='keywords' content='motor bike loan, two wheeler loan interest rate, second hand bike loan, 0 interest two wheeler loan, bike loan apply online' />
            <link rel="canonical" href="https://thefinmaster.com/two_wheeler_loan" />
            <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
            <meta name="robots" content="max-video-preview:-1" />
          </Helmet>
          <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
            <ol className="list-none p-0 inline-flex">
              <li className="flex items-center">
                <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
                <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </li>
                <li className="flex items-center">
                <span className="text-gray-500 ">Two Wheeler Loan</span>
              </li>  
              
            </ol>
          </nav>
            <div className="w-full flex flex-col items-center">
              <div className="w-full flex justify-center">
                <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
                  <div className="w-full sm:w-[50%]">
                    <div className="w-[90%]">
                      <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                        <span className="text-blue-600 ">
                        Ride home your dream bike with quick Two-Wheeler Loans
                        </span>{" "}
                        low EMIs, fast approval, and minimal paperwork

                      </h1>
                      {/* <a href="#insurance_plans">
                        <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                          See Plans
                        </button>
                      </a> */}
                    </div>
                  </div>
                  <div className="w-full sm:w-[50%]">
                    <img
                      className="w-full max-w-full"
                      src="https://www.cashe.co.in/wp-content/uploads/2023/12/what-is-two-wheeler-loan.png"
                      alt="Two Wheeler-loan"
                    />
                  </div>
                </div>
             </div>
      
             </div>
             <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
          <p className="text-lg md:text-base lg:text-lg text-center">
          Gear up for smooth riding with TheFinMaster.com!. Our platform brings together offers from various lenders, allowing you to compare interest rates, repayment terms, and down payment requirements to find the perfect fit for your financing needs. TheFinMaster.com empowers you with knowledge to find the best bike loan deal and accelerate towards owning your dream ride.    </p>
              </div>
              <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-3/4">
      <div id="loan_plans" className="lg:pr-6 md:px-4 px-2">
      {loading ? (
              <div className="text-center py-10">Loading Loan options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : loanData.length === 0 ? (
              <div className="text-center py-10">
                No TwoWheelerLoan Loan options available at the moment.
              </div>
        ) : (
          loanData.map((loan) => (
            <div
              key={loan.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/two_wheeler_loan/${loan.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={loan.page_title || "Loan Provider"}
                      src={loan.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Interest Rate</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {loan.interest_rate}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Loan Amount </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.loan_amount}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Processing Fee</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.processing_fee}
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={loan.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/two_wheeler_loan/${loan.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                    See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
         </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <a href="https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/sidebanner.png" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a>
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>

      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
          What is a Two-Wheeler Loan?
          </h2>
          <p className="text-gray-600 leading-relaxed">
          A two-wheeler loan is a type of vehicle loan that helps individuals purchase a bike or scooter without paying the full amount upfront. Banks, NBFCs, and financial institutions offer these loans with flexible repayment tenures and competitive interest rates.

          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
          Two-wheeler loans are typically secured loans, where the purchased vehicle itself acts as collateral until the loan is fully repaid. However, some lenders may offer unsecured two-wheeler loans based on the applicant’s creditworthiness.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Key stats 
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
        <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Financing Penetration
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            Approximately 75% of two-wheeler purchases in India are financed through loans, indicating a high reliance on financing options among consumers.

            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📈</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Market Size Growth
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            The two-wheeler loan market in India was valued at USD 8.34 billion in 2024 and is projected to reach USD 14.89 billion by 2030, exhibiting a Compound Annual Growth Rate (CAGR) of 6.78% during the forecast period.

            </p>
          </div>

       

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📜</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Lender Market Share
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            In the two-wheeler loan segment, banks hold a 60% share, while Non-Banking Financial Companies (NBFCs) account for 40%, reflecting the distribution of lending services in this market.



            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center">
        Types of Two-Wheeler Loans
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 text-center max-w-3xl mx-auto">
        Financial institutions offer different types of two-wheeler loans to cater to diverse customer needs. Here are the main types:

        </p>

        {/* Responsive Grid Layout */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {loanTypes.map((loan, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="bg-white shadow-md border border-gray-200 rounded-xl p-6 flex flex-col"
            >
              <div className="text-3xl text-blue-500">{loan.icon}</div>
              <h3 className="text-xl font-semibold mt-3">{loan.name}</h3>
              <p className="mt-2 text-gray-600">{loan.description}</p>
            </motion.div>
          ))}
        </div>
      </div>



      <div className="p-8 max-w-7xl mx-auto">
      {/* Header */}
      <h2 className="text-4xl font-bold text-center text-gray-900 mb-6">
      Types of Two-Wheeler Loans
      </h2>
      <p className="text-lg text-center text-gray-600 mb-10">
      Financial institutions offer different types of two-wheeler loans to cater to diverse customer needs. Here are the main types:      </p>

      {/* Benefits Grid */}
      <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-8">
        {benefitshealth.map((benefit, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center"
          >
            <div className="flex justify-center mb-4">{benefit.icon}</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{benefit.title}</h3>
            <p className="text-gray-600">{benefit.description}</p>
          </div>
        ))}
      </div>
    </div>





      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-center mt-16 mb-6">
        Key Components of a Two-Wheeler Loan
        </h2>
        <p className="text-gray-600 text-center mb-8">
        A two-wheeler loan consists of several crucial elements that determine the overall cost, repayment structure, and eligibility. Here are the key components:
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300 flex items-start gap-4"
            >
              {criteria.icon}
              <div>
                <h3 className="font-semibold text-lg mb-2">{criteria.title}</h3>
                <ul className="list-disc list-inside text-gray-600 text-md">
                  {criteria.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold text-center mb-6">
         Eligibility Criteria for a Two-Wheeler Loan
        </h2>
        <p className="text-center text-gray-600 mb-10">
        To avail of a two-wheeler loan, applicants must meet certain eligibility criteria set by financial institutions. The requirements may vary slightly among lenders, but the general criteria are as follows:

        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {componentsData1.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-3">
                {item.icon}
                <h3 className="text-lg font-semibold">{item.title}</h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 space-y-1 text-md">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-4 py-10">
     
       
        <h2 className="text-3xl font-bold text-center mb-6"> Why Two-Wheeler Loan? </h2>
    
      <p className="text-center text-gray-600 mb-10">
        When purchasing a two-wheeler, buyers often consider financing options such as two-wheeler loans and personal loans.
        While both can serve the purpose, a two-wheeler loan is often a more suitable and cost-effective option.
      </p>

      <div className="overflow-x-auto border rounded-lg shadow-md">
        <table className="min-w-full text-md text-left text-gray-700 dark:text-gray-300">
          <thead className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 text-md uppercase">
            <tr>
              <th className="px-4 py-3 flex items-center gap-2">
                <FaBalanceScale className="text-blue-500" />
                Feature
              </th>
              <th className="px-4 py-3">Two-Wheeler Loan</th>
              <th className="px-4 py-3">Personal Loan</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {[
              {
                feature: "Purpose",
                twoWheeler: "Specifically for purchasing a two-wheeler",
                personal: "Can be used for any purpose, including buying a two-wheeler",
              },
              {
                feature: "Interest Rate",
                twoWheeler: "Lower (8% - 18% p.a.)",
                personal: "Higher (10% - 24% p.a.)",
              },
              {
                feature: "Loan Amount",
                twoWheeler: "Covers up to 90%-100% of the bike's cost",
                personal: "Loan amount depends on income and credit score",
              },
              {
                feature: "Collateral",
                twoWheeler: "The bike itself acts as collateral",
                personal: "Unsecured loan, no collateral needed",
              },
              {
                feature: "Loan Tenure",
                twoWheeler: "1 - 5 years",
                personal: "1 - 7 years",
              },
              {
                feature: "Processing Time",
                twoWheeler: "Faster, as it is a secured loan",
                personal: "May take longer due to risk assessment",
              },
              {
                feature: "Eligibility",
                twoWheeler: "Easier approval with flexible eligibility",
                personal: "Stricter eligibility and credit score requirements",
              },
              {
                feature: "Down Payment",
                twoWheeler: "Required in most cases",
                personal: "No down payment required",
              },
            ].map((row, idx) => (
              <tr key={idx}>
                <td className="px-4 py-3 font-medium">{row.feature}</td>
                <td className="px-4 py-3">{row.twoWheeler}</td>
                <td className="px-4 py-3">{row.personal}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </section>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
          Pros and Cons of a Two-Wheeler Loan
          </h1>
          <p className="text-gray-700 mb-6">✅ Pros:</p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
            Cons of a Two-Wheeler Loan
          </h1>
          <p className="text-gray-700 mb-6">❌ Cons</p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 p-6 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">

          Choosing the Right Two-Wheeler Loan: Key Factors to Consider          </h1>
          <p className="text-gray-700 mb-6">
          Selecting the best two-wheeler loan requires evaluating multiple factors to ensure affordability and ease of repayment. Here are the essential aspects to consider:
          </p>

          {points3.map((item, index) => (
            <div
              key={index}
              className="p-5 mb-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {item.title}
              </h2>
              <ul className="list-disc list-inside text-gray-600 mt-2">
                {item.points.map((point, idx) => (
                  <li key={idx} className="mt-1">
                    ✔ {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 p-6">
        <h1 className="text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TwoWheelerLoanNew;
